import Scheduler from "../singleton/scheduler";

export default {

    getAll: Scheduler.getAll.bind(Scheduler),

    get: Scheduler.get.bind(Scheduler),

    create: Scheduler.create.bind(Scheduler),

    update: Scheduler.update.bind(Scheduler),

    delete: Scheduler.delete.bind(Scheduler),

    rename: Scheduler.rename.bind(Scheduler),

    getData: Scheduler.getData.bind(Scheduler),

    setColors: Scheduler.setColors.bind(Scheduler)

}